import React from 'react';

import { AmplitudeFlagKeys } from '../../resources/amplitude/amplitudeFlags';
import useIsExperimentActive from '../../resources/amplitude/useIsExperimentActive';

import { ArrivalStepLegacy } from './legacy/ArrivalStep';
import { ArrivalStepV2 } from './v2/ArrivalStep';

export const ArrivalStep = () => {
  const flagEnabled = useIsExperimentActive(AmplitudeFlagKeys.obArrivalStepImprovements);

  return flagEnabled ? <ArrivalStepV2 /> : <ArrivalStepLegacy />;
};
